import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('TwoColumnWidget', {
  attributes: {
    column_1: 'widgetlist',
    column_2: 'widgetlist',
    column_1Width: ['enum', { values: ['1','2','3','4','5','6','7','8','9','10','11','12'] }],
    gridSize: ['enum', { values: ['small', 'default', 'large'] }],
    keepColumns: ['enum', { values: ['Yes', 'No'] }],
  },
});

const TwoColumnWidget = Scrivito.connect(({ widget }) => {
  const leftWidth = parseInt(widget.get('column_1Width') || '6', 10);
  const rightWidth = 12 - leftWidth;
  const keepColumns = widget.get('keepColumns');
  const deviceClass = keepColumns === 'Yes' ? 'xs' : 'md';

  return (
    <div className="row">
      <div className={`col-${deviceClass}-${leftWidth}`}>
        <Scrivito.ContentTag tag="div" attribute="column_1" content={widget} />
      </div>
      <div className={`col-${deviceClass}-${rightWidth}`}>
        <Scrivito.ContentTag tag="div" attribute="column_2" content={widget} />
      </div>
    </div>
  );
});

Scrivito.provideComponent('TwoColumnWidget', TwoColumnWidget);

Scrivito.provideEditingConfig('TwoColumnWidget', {
  title: 'Two Column Layout',
  properties: ['column_1Width', 'gridSize', 'keepColumns'],
  attributes: {
    column_1: { title: 'Left Column' },
    column_2: { title: 'Right Column' },
    column_1Width: {
      title: 'Left Column Width',
      description: 'Out of 12 grid columns. Right column takes the remainder.',
      values: [
        { value: '2', title: '2/12' }, { value: '3', title: '3/12 (¼)' },
        { value: '4', title: '4/12 (⅓)' }, { value: '5', title: '5/12' },
        { value: '6', title: '6/12 (½)' }, { value: '7', title: '7/12' },
        { value: '8', title: '8/12 (⅔)' }, { value: '9', title: '9/12 (¾)' },
        { value: '10', title: '10/12' },
      ],
    },
    gridSize: {
      title: 'Gutter Size',
      values: [
        { value: 'small',   title: 'Small' },
        { value: 'default', title: 'Default' },
        { value: 'large',   title: 'Large' },
      ],
    },
    keepColumns: {
      title: 'Keep Columns on Mobile',
      values: [
        { value: 'Yes', title: 'Yes – stay side by side' },
        { value: 'No',  title: 'No – stack vertically' },
      ],
    },
  },
  initialContent: {
    column_1Width: '6',
    gridSize: 'default',
    keepColumns: 'No',
  },
});

export default TwoColumnWidget;
